import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=ed97973c&scoped=true"
import script from "./CreateRole.vue?vue&type=script&lang=js"
export * from "./CreateRole.vue?vue&type=script&lang=js"
import style0 from "./CreateRole.vue?vue&type=style&index=0&id=ed97973c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed97973c",
  null
  
)

export default component.exports